import { InterestSector } from '@interfaces/interestSector.interface';

import api from './';

export const { useGetInterestSectorsQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getInterestSectors: build.query<InterestSector[], string>({
      query: (marketCategoryName) => ({
        url: 'interest-sector',
        params: { marketCategoryName },
      }),
    }),
  }),
});
